<template>
  <div id="earth">
    <div id="earthdiv" style="height:100%"></div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';
import 'echarts-gl';
// import '../../../node_modules/echarts/map/js/china.js'
import '../../../node_modules/echarts/map/js/world.js'
import { countryInWorld } from './map_country'
import request from '@/utils/request'

export default {
  name: 'earth',
  data() {
    return {
      // 需要合并对象，样式
      options: {},
      data: [],
      queryParams: {}
    };
  },
  created() {},
  mounted() {
    const { refreshData, refreshChart } = this;

    const chartData = []
    refreshChart(chartData)

    refreshData()
    // this.queryParams.QueryPlantRealPower = 'Y'
    // this.timer = setInterval(this.refreshData, 1000 * 60)
  },
  methods: {
    testEarth(value) {
      console.log('from testEarth:' + value)
    },
    refreshData(value) {
      const { refreshChart } = this;

      if (value === undefined) {
        value = this.queryParams
      } else {
        this.queryParams = value
      }
      request({
        url: 'Kanban/PlantCoordinate',
        method: 'post',
        data: this.queryParams
      }).then(response => {
        const res = response
        console.log(res)
        let chartData = []
        try {
          chartData = res.data.Data.PlantList
        } catch {
        }
        refreshChart(chartData)
      })
    },
    refreshChart(chartData) {


        function color2rgb(color) {
            var r = parseInt(color.substr(1, 2), 16);
            var g = parseInt(color.substr(3, 2), 16);
            var b = parseInt(color.substr(5, 2), 16);
            return new Array(r, g, b);
        }
        function rgb2color(rgb) {   
            var s = "#";   
            for (var i = 0; i < 3; i++)  
            {    
                var c = Math.round(rgb[i]).toString(16);   
                if (c.length == 1) 
                c = '0' + c; s += c;
            }
            return s.toUpperCase();
        }
        var ColorA = "#C1E7FD", ColorB = "ffff00",ColorC = "#ffa500";
        function gradient() {   
            var str = coldata;
            var result = "";   
            var Step = str.length - 1;    
            var Gradient = new Array(3);  
            var A = color2rgb(ColorA);  
            var B = color2rgb(ColorB);
            var C = color2rgb(ColorC);
            for (var N = 0; N <= Step; N++)  
            {
                if (coldata[N].value < 700000) {
                    for (var c = 0; c < 3; c++) // RGB通道分别进行计算   
                    { Gradient[c] = A[c] + (B[c] - A[c]) / 700000 * coldata[N].value; }
                }
                else {
                    for (var c = 0; c < 3; c++) // RGB通道分别进行计算   
                    { Gradient[c] = B[c] + (C[c] - B[c]) / 700000 * (coldata[N].value-700000); }
                }
                coldata[N]["itemStyle"] = {
                    normal: {
                        areaColor: rgb2color(Gradient)
                    }
                }
            }           
        }
        var coldata = countryInWorld;       
        gradient();
      var rawData = [];
      const data = chartData
      var geoCoordMap = {};
      for (var i = 0; i < data.length; i++) {
        var a = data[i].PlantName;
        geoCoordMap[a] = [data[i].Longitude, data[i].Dimension];
        var c = [];
        c.push(data[i].PlantName);
        c.push(data[i].PowerValue);
        rawData.push(c);
      }
      function makeMapData(rawData) {
        var mapData = [];
        for (var i = 0; i < rawData.length; i++) {
          var ddd = rawData[i].slice(1);
          var ss = rawData[i][0];
          var geoCoord = geoCoordMap[rawData[i][0]];
          if (geoCoord) {
            mapData.push({
              name: rawData[i][0],
              value: geoCoord.concat(rawData[i].slice(1))
            });
          }
        }
        return mapData;
      };

var option = {
    geo: {
        map: 'world',
        silent: true,
        label: {
            emphasis: {
                show: true,
                areaColor: '#eee'
            }
        },
        itemStyle: {
            normal: {
                borderWidth: 0.2,
                borderColor: '#404a59',
                areaColor: '#C1E7FD'
            }
        },
        roam: true,
        regions: coldata,
        layoutCenter: ['50%', '55%'],
        layoutSize: 700
    },
    series: [
        {
            name: '工厂',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbolSize: 8,
            data: makeMapData(rawData),
            activeOpacity: 1,
            label: {
                normal: {
                    formatter: '{b}',
                    position: 'right',
                    show: false,
                    color: '#fff'
                },
                emphasis: {
                    show: true
                }
            },
            zoom: 2.8,
            symbolSize: 10,
            itemStyle: {
                normal: {
                    borderColor: '#fff',
                    color: '#FCAE63',
                }
            }
        }
    ]
};      
var chart1 = echarts.init(document.getElementById('earthdiv'));
chart1.setOption(option);

      /*
      var rawData = [];
      const data = chartData
      var geoCoordMap = {};
      for (var i = 0; i < data.length; i++) {
        var a = data[i].PlantName;
        geoCoordMap[a] = [data[i].Longitude, data[i].Dimension];
        var c = [];
        c.push(data[i].PlantName);
        c.push(data[i].PowerValue);
        rawData.push(c);
      }
      function makeMapData(rawData) {
        var mapData = [];
        for (var i = 0; i < rawData.length; i++) {
          var ddd = rawData[i].slice(1);
          var ss = rawData[i][0];
          var geoCoord = geoCoordMap[rawData[i][0]];
          if (geoCoord) {
            mapData.push({
              name: rawData[i][0],
              value: geoCoord.concat(rawData[i].slice(1))
            });
          }
        }
        return mapData;
      };
      var chart1 = echarts.init(document.getElementById('earthdiv'));
      var option = {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          formatter: function (params) {
            var html = '';
            var PlantName = params.data.name;
            var Value = params.data.value[2];
            html += PlantName + '\n';
            html += Value
            return html;
          }
        },
        geo: {
          map: 'world',
          silent: true,
          label: {
            emphasis: {
              show: false,
              areaColor: '#eee'
            }
          },
          itemStyle: {
            normal: {
              borderWidth: 0.2,
              borderColor: '#404a59',
              areaColor: '#00a4f6'
            }
          },
          left: '5%',
          top: '2%',
          right: '5%',
          roam: true
        },
        series:
          [
            {
              name: '功率',
              type: 'scatter',
              coordinateSystem: 'geo',
              // symbolSize: 4,
              data: makeMapData(rawData),
              activeOpacity: 1,
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'right',
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              itemStyle: {
                normal: {
                  borderColor: '#fff',
                  color: '#577ceb'

                }
              }
            }
          ]
      };
      chart1.setOption(option);
      */
    }
  }
};
</script>
<style lang="less" scoped>
#earth {
  position: relative;
  width:100%;
  height: 58%;
  top: 20%;
  background-color: #17293d;
  box-sizing: border-box;
}
</style>
